<script lang="ts">
	import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.ts';
	import { HeniLogo } from '$global/assets/logos/HeniLogo';
	import { IconLink } from '$global/components/IconLink';
	import { getNavBarContext } from '$global/features/navigation/utils/getNavBarContext/getNavBarContext';

	const context = getNavBarContext();
	const open = context?.popover?.states?.open;
</script>

{#if $open}
	<HeniLogo
		color={$open ? 'gray-900' : 'gray-0'}
		class={'xs:scale-100 origin-left scale-75'}
	/>
{:else}
	<IconLink
		dataCy="header"
		href={GlobalRoutes.Home}
		label="See HENI home page"
		class="outline-none"
	>
		<HeniLogo
			color={$open ? 'gray-900' : 'gray-0'}
			class={'xs:scale-100 origin-left scale-75'}
		/>
	</IconLink>
{/if}
